module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_location_photowedding@3x-07cf650bb6d694c8a0592651ef25d67c.webp";